import React from 'react';

const FinalCtaSection = () => {
  // Function to handle smooth scrolling to sections
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <>
      {/* Final CTA Section start */}
      <div className="call-to-action-area bg-gray pd-top-100 pd-bottom-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div className="section-title">
                <h2 className="title mb-4">
                  ¿Listo para firmar más rápido y con más control?
                </h2>
                <p className="content mb-4">
                  Empieza hoy con FirmasCheck.
                </p>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="btn btn-base btn-lg"
                >
                  Contáctanos →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Final CTA Section end */}
    </>
  );
};

export default FinalCtaSection;
